module.exports = __webpack_public_path__ + "img/logo_rivieranuragica.5fe02999.jpg";